function o(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(i) {
      Promise.resolve().then(function() {
        n = void 0, i(e());
      });
    })), n;
  };
}
export {
  o as default
};
//# sourceMappingURL=debounce4.mjs.map
